<template>
  <div class="card" :class="data.active ? 'card-green' : 'card-red'">
   <div class="aspect-ratio">
     <h4>{{data.name.substring(0, 20)}}</h4>

      <div @click="openCard(data)" class="btn-round"></div>
      <div @click="openModal(data)" class="triangle triangle-1"></div>
     
        <l-modal
          :is-product-deletion-pending="isProductDeletionPending(data.uuid)"
          @deleteProduct="deleteUserProduct"
          :value="data"
          v-if="modal"
          @close="closeModal"
        >
        </l-modal>
    
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import lModal from "@/components/modal";
export default {
  components: {
    lModal
  },
  props: {
    data: Object
  },
  data() {
    return {
      active: false,
      modal: false
    };
  },
  computed: {
    ...mapGetters("posts", ["isProductDeletionPending"])
  },
  methods: {
    ...mapActions("posts", ["deleteUserProduct"]),
    closeModal() {
      this.modal = false;
    },
    openCard(event) {
      this.$emit("open-card", event);
    },
    openModal(event) {
      this.modal = true;
    }
  }
};
</script>

<style>
.card {
  flex-basis: calc((100% - 30px) / 3);
  background: #cecdcd;
  color: #000;
  position: relative;
  margin: 6px 5px;
  overflow: hidden;
  border-radius: 10px;
  word-wrap: break-all !important;
  transition: 190ms;
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .card {
    flex-basis: calc((90% - 200px) / 3);
  margin: 6px 45px;
  }

}

/* Landscape */
@media only screen 
  and (min-width: 1024px) 
  and (max-height: 1366px) 
  and (orientation: landscape) 
  and (-webkit-min-device-pixel-ratio: 1.5) {
  .card {
    flex-basis: calc((90% - 100px) / 3);
  margin: 6px 45px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .card {
    flex-basis: calc((70% - 160px) / 3);
    margin: 6px 10px;
  }
}


@media screen and (min-width: 1200px) {
  .card {
  flex-basis: calc((60% - 60px) / 3);
  margin: 6px 10px;
}
}

.card h4 {
  text-align: left;
  font-size: 20px;
  float: left;
  margin: 0;
  line-height: 1.2;
  padding: 25px 4px 0 2px;
}
.card-red {
  background: #ff6059;
}
.card-green {
  background: #9f9 !important;
}
.card-green-dark {
  background: rgba(41, 204, 65, 1);
}
.card-orange {
  background: #ffbd2e;
}

.btn-round {
  background: #ffbd2e;
  border: none;
  border-radius: 100%;
  color: white;
  top: 0;
  right: 0;
  padding: 13px;
  width: 10px;
  height: 10px;
  position: absolute;
  margin: 4px 4px;
  cursor: pointer;
}

.triangle {
  display: inline-block;
  margin: 0 2px;
  overflow: hidden;
  vertical-align: middle;
}
.triangle-1 {
  position: absolute;
  bottom: -2px;
  right: 0px;
  left: -5px;
  width: 0px;
  height: 0px;
  border-bottom: solid 17px rgba(41, 204, 65, 1);
  border-left: solid 17px rgba(41, 204, 65, 1);
  border-right: solid 17px transparent;
  border-top: solid 17px transparent;
}
*,
*:before,
*:after {
  box-sizing: border-box;
}

.modal-enter {
  opacity: 0;
    transform: scale(1.1);
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter-active, .modal-leave-active {
  transform: scale(1.1);
}
.modal-enter, .modal-leave-to {
  opacity: 0
}

</style>